module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "com-model"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "member-detail"
  }, [_c('div', {
    staticClass: "member-detail-title flex m-b-14"
  }, [(_vm.companyInfo.isVip) ? _c('img', {
    staticStyle: {
      "with": "34px",
      "height": "34px",
      "margin-right": "18px"
    },
    attrs: {
      "src": require("../../assets/images/home/vip_icon.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.companyInfo.name))])]), _vm._v(" "), (_vm.companyInfo.vipStart || _vm.companyInfo.vipEnd) ? _c('div', {
    staticClass: "flex "
  }, [(_vm.companyInfo.vipStart) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("最近购买时间：")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.companyInfo.vipStart.split(" ")[0]))])] : _vm._e(), _vm._v(" "), (_vm.companyInfo.vipEnd) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("会员到期时间：")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.companyInfo.vipEnd.split(" ")[0]))])] : _vm._e(), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "color": "#057CF9"
    },
    attrs: {
      "to": {
        path: '/index/finance'
      }
    }
  }, [_vm._v("支付购买记录")])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vip-list-warper"
  }, [_c('div', {
    staticClass: "tab-list flex m-b-24"
  }, _vm._l((_vm.vipList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "tab-item",
      class: {
        active: _vm.vipIndex == index
      },
      on: {
        "click": function($event) {
          _vm.vipIndex = index
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    }), _vm._v("\n                    " + _vm._s(item.name) + "\n                ")])
  })), _vm._v(" "), (_vm.currentVip) ? _c('div', {
    staticClass: "vip-content"
  }, [_c('div', {
    staticClass: "vip-title"
  }, [_vm._v("会员套餐包含内容")]), _vm._v(" "), _c('div', {
    staticClass: "content-list flex"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.currentVip.collNum) + "次简历免费加入次数")]), _vm._v(" "), _c('p', [_vm._v("平台海量人才任你挑选")])]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('p', [_vm._v("最高" + _vm._s(_vm.currentVip.recruitNum) + "个岗位发布上限")]), _vm._v(" "), _c('p', [_vm._v("大量招聘需求轻松应对")])]), _vm._v(" "), _vm._m(3, false, false)])]) : _vm._e(), _vm._v(" "), (_vm.currentVip) ? _c('div', {
    staticClass: "vip-long m-b-20"
  }, [_c('p', [_vm._v("当前公司：" + _vm._s(_vm.companyInfo.name))]), _vm._v(" "), _c('p', [_vm._v("有效时长：" + _vm._s(_vm.currentVip.duration) + "个月")]), _vm._v(" "), _c('p', [_vm._v("充值方式：")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pay-type-list flex",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "type-item flex flex-center",
    class: {
      active: _vm.payType == 'alipay'
    },
    on: {
      "click": function($event) {
        _vm.selPayway('alipay')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "44px",
      "height": "44px",
      "margin-right": "16px"
    },
    attrs: {
      "src": require("../../assets/images/zhifubao_icon.png")
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("\n                    支付宝\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "type-item flex flex-center",
    class: {
      active: _vm.payType == 'wxpay'
    },
    on: {
      "click": function($event) {
        _vm.selPayway('wxpay')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "44px",
      "height": "44px",
      "margin-right": "16px"
    },
    attrs: {
      "src": require("../../assets/images/weixin_icon.png")
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("\n                    微信\n                ")])]), _vm._v(" "), (_vm.currentVip) ? _c('div', {
    staticClass: "buys-money"
  }, [_vm._v("应付金额："), _c('span', [_vm._v(_vm._s(_vm.currentVip.price))]), _vm._v(" 元")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    staticStyle: {
      "width": "250px"
    },
    on: {
      "click": _vm.buyVip
    }
  }, [_vm._v("立即购买")])])]), _vm._v(" "), (_vm.currentVip) ? _c('el-dialog', {
    attrs: {
      "title": "扫码支付",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "pay-qr flex flex-column flex-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.base64Img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-qr-text"
  }, [_c('p', [_vm._v("请使用" + _vm._s(_vm.payType == 'alipay' ? '支付宝' : '微信') + "扫码支付")]), _vm._v(" "), _c('p', [_vm._v("支付金额："), _c('span', [_vm._v(_vm._s(_vm.currentVip.price))]), _vm._v(" 元")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-model-title"
  }, [_c('span', [_vm._v("会员特权")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member/vip_icon_2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member/vip_icon_1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member/vip_icon_3.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("提高企业曝光率")]), _vm._v(" "), _c('p', [_vm._v("专业一对一客户服务")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0102e8b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/member/info.vue
// module id = 852
// module chunks = 1